// tslint:disable
export const dicoGPI = {
    id: "1",
    cover: {
        image: "gpi",
        title: "Garantie Prévoyance Individuelle",
        target: "Particuliers âgés de 18 ans à 70 ans.\nToutes CSP (Hors TNS), Salariés, Auto Entrepreneurs, Sans emploi, Retraités.",
        topic: "Un contrat d’assurance temporaire décès qui permet le versement d’un capital en cas de Décès ou d’Invalidité Absolue et Définitive.",
        tag: "Décés",
        age: "18 / 70 ans",
    },
    conditions: [
        "Avoir sa résidence fiscale en France.",
        "Avoir un compte bancaire en France.",
        "Être âgé de 18 ans minimum ou 16 ans minimum avec émancipation des parents.",
    ],
    plus: [
        { icon: "currency", text: "Libre choix du capital entre 10 000 € et 200 000 €." },
        { icon: "account", text: "Désignation libre du ou des bénéficiaires." },
        { icon: "medical", text: "Déclaration de santé simplifiée." },
        {
            icon: "calcul",
            text: "Cotisation calculée en fonction du montant du capital et de l’âge au moment de l’adhésion.",
        },
        { icon: "edit", text: "Possibilité de modifier les garanties après 12 mois révolus d’adhésion." },
        { icon: "shield", text: "Services d’assistance essentiels." },
    ],

    /* DOCUMENTS ANNEXES */

    docs: {
        adhesion: [
            {
                label: "Notice d’information",
                url: require("./documents/adhesion/notice_information.pdf"),
                required: true,
            },
            {
                label: "Garanties d’assistance",
                url: require("./documents/adhesion/garanties_assistance.pdf"),
                required: true,
            },
            {
                label: "Questionnaire médical simplifié",
                url: require("./documents/adhesion/questionnaire_medical_simplifie.pdf"),
                required: true,
                condition: "product.healthState === 'no' || product.signDeclaration === 'no'",
            },
            {
                label: "Acte sous seing privé d'acceptation bénéficiaire à titre onéreux",
                url: require("./documents/adhesion/acte_sous_seing_prive.pdf"),
                required: false,
            },
            {
                label: "Manuel de gestion",
                url: require("./documents/adhesion/manuel_de_gestion.pdf"),
                required: false,
                condition: "false",
            },
        ],
        common: [
            { label: "Fiche IPID", url: require("./documents/common/fiche_IPID.pdf"), required: true },
            {
                label: "Plaquette commerciale",
                url: require("./documents/common/plaquette_commerciale.pdf"),
                required: false,
            },
            {
                label: "Dossier d’Entrée en Relation (DER)",
                url: require("../common/documents/DER_Prévoyance_Individuelle_Dynamique.pdf"),
                required: true,
            },
            {
                label: "Déclaration d’Etat de Santé",
                url: require("./form/form-DES.pdf"),
                required: true,
                isForm: true,
            },
        ],
    },

    /********************/

    summary: {
        image: "gpi",
        paragraphs: [
            {
                headline: "Choix du montant du capital",
                text: "Choix du montant du capital compris entre 10 000 € et 200 000 €.",
            },
            {
                headline: "Délai de carence",
                text: "Décès – IAD ou Décès doublement en cas d’accident: <ul><li>pas de délai de carence.</li></ul> Incapacité Temporaire Totale (ITT) / Invalidité Permanente Totale (IPT) : <ul><li>90 jours suite à une maladie</li><li>Aucun délai suite à un accident.</li></ul>",
            },
            {
                headline: "Cotisations",
                text: "Cotisations déterminées en fonction du montant du capital choisi et de l’âge à l’adhésion.",
            },
        ],
    },
    details: {
        paragraphs: [
            {
                headline: "Garanties Proposées",
                text: "<table><tr><th>Garanties obligatoires</th><th>Garanties Optionelles</th></tr><tr><td>Décès – Invalidité Absolue et Définitive (IAD)</td><td>Doublement en cas d’accident</td></tr><tr><td>Assistance</td><td>Incapacité Temporaire Totale (ITT) / Invalidité Permanente Totale (IPT)</td></tr></table>",
            },
            {
                headline: "Bornes d'adhésion",
                text: "<table><tr><th>Garanties/Âge</th><th>Décés</th><th>IAD</th><th>ITT</th><th>IPT</th></tr><tr><td>Âge max. adhésion</td><td>70</td><td>61</td><td>61</td><td>61</td></tr></tr><tr><td>Âge au therme</td><td>75</td><td>62</td><td>67</td><td>62</td></tr></table>",
            },
            {
                headline: "Montant des capitaux",
                text:
                    "Décés-IAD ou doublement en cas d'accident:<ul><li>Par tranche de 2 500 € jusqu’à 15 000 €.</li><li>Par tranche de 5 000 € jusqu’à 50 000 €.</li>" +
                    "<li>Par tranche de 10 000 € au-delà de 50 001 €.</li></ul> ITT ou IPT<ul><li>Par tranche de 5 € ou 10 €</li></ul>",
            },

            {
                headline: "Exonération des cotisations",
                text: "<ul><li>En cas d’Invalidité Permanente Totale : oui.</li><li> En cas d’Incapacité Temporaire Totale : franchise de 90 jours et exonération totale de la cotisation limitée à 1 095 jours.</li></ul>",
            },
            {
                headline: "Bénéficiaire(s)",
                text: "<ul><li>En cas de Décès : clause standard ou clause libre (cf. BA).</li><li>En cas d’Invalidité Absolue et Définitive (IAD) / Incapacité Temporaire Totale (ITT) / Invalidité Permanente Totale (IPT) : l’assuré(e).</li></ul>",
            },
            {
                headline: "Les formalités médicales",
                text: "<table><tr><th></th><th>< à 51 ans</th><th>≥ à 51 ans</th></tr><tr><td>Capital décès inférieur à 100 000€:</td><td>Profil de santé</td><td>Questionnaire Médical Simplifié (QMS)<sup>*</sup></td></tr><tr><td>Capital décès égale ou supérieur à 100 000€:</td><td>Questionnaire Médical Simplifié (QMS)</td><td>Questionnaire Médical Simplifié (QMS)* + Bilan sanguin (BS) + Visite Médicale Cardiologie avec Électrocardiogramme (VMC/ECG) + Radio Thorax</td></tr></table>",
            },
            {
                headline: "Garanties d'assistance",
                text: "<ul><li>Assistance décès, à la recherche d’emploi, vie quotidienne, déménagement, aux enfants mineurs.</li><li>Aide à l’organisation des obsèques, psychologique, au conjoint...</li></ul>",
            },
            {
                headline: "Territorialité",
                text: "France Métropolitaine, DROM.",
            },
            {
                headline: "Choix des franchises",
                text: "15 jours / 30 jours / 42 jours / 60 jours / 90 jours et 365 jours.",
            },
        ],
        mentions: ["<sup>*</sup> à la charge du client."],
    },
    benchmark: {
        title: "Garantie Prévoyance Individuelle",
        head: [
            { headline: "" },
            { headline: "ag2r La Mondiale", subheading: "Garantie Prévoyance Individuelle" },
            { headline: "BANQUE POPULAIRE", subheading: "Fructi-Famille" },
            { headline: "BNP PARIBAS", subheading: "Protection familiale" },
            { headline: "ALLIANZ", subheading: "Allianz Prévoyance" },
            { headline: "LCL", subheading: "Prévillon" },
        ],
        body: [
            {
                cells: [
                    "Garanties",
                    "- Capital décès / invalidité<br>- Indemnités journalières<br>- Exonérations des paiements<br>- Option doublement accident",
                    "- Capital décès<br>- Capital invalidité",
                    "- Capital décès<br>- Capital invalidité<br>- Rente éducation<br>- Option doublement accident",
                    "- Capital décès / invalidité<br>- Indemnités journalières<br>- Exonérations des paiements<br>- Rente au conjoint<br>- Rente éducation",
                    "- Capital décès<br>- Capital invalidité<br>- Rente éducation<br>- Doublement et triplement accident",
                ],
            },
            {
                cells: [
                    "Formalités médicales",
                    "Déclaration d’Etat de Santé <br/>< 51 ans et pour un capital max de 100 000 euros<br/><br/>Questionnaire Médical > 51 ans",
                    "Déclaration  de Santé<br>< 55 ans pour un capital max de 100 000€<br/><br/>Questionnaire Médical > 55 ans ",
                    "Questionnaire de santé simplifiée<br><69 ans pour un capital max de 50 000€<br/><br/>Questionnaire Médical entre 49 ans et 69 ans pour un capital compris entre 69 000€  175 000€",
                    "Formalités médicales en fonction du capital souscrit et de l‘âge",
                    "Déclaration de santé < 60 ans pour un capital maximum de 30 000€<br /><br/>Questionnaire de santé pour un capital compris entre 30 000 et 75 000 €",
                ],
            },
            {
                cells: [
                    "Montants des capitaux",
                    "Entre 10 000 € et 200 000 € ",
                    "Entre 15 000 € et 149 000 € (tranche de  1 000 €)",
                    "Entre 30 000 € et  300 000 € (tranche de  2 000 €)",
                    "À partir de 15 000 € (Libre choix)",
                    "Entre 16 000 € et  75 000 € (Libre choix)",
                ],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels* <br/>(45 ans)",
                    "Pour 30 000 € de capital : 9,87 €",
                    "Pour 30 000 € de capital : 14,03 €",
                    "Pour 30 000 € de capital : 13,21 €",
                    "Pour 30 000 € de capital : 9,90  €",
                    "Pour 30 000 € de capital : 12,36 €",
                ],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels* <br/>(55 ans)",
                    "Pour 30 000 € de capital : 21,52 €",
                    "Pour 30 000 € de capital : 30,28 €",
                    "Pour 30 000 € de capital : 32,12 €",
                    "Pour 30 000 € de capital : 25,44 €",
                    "Pour 30 000 € de capital : 29,03 €",
                ],
            },
        ],
        mention:
            "<sup>*</sup> Les tarifs n’incluent pas les garanties IPT et ITT et autres garanties optionnelles que peuvent proposer certains assureurs.",
    },
};



// WEBPACK FOOTER //
// ./src/data/products/gpi/dico.ts